import { render, staticRenderFns } from "./processState2.vue?vue&type=template&id=38997407&scoped=true"
import script from "./processState2.vue?vue&type=script&lang=js"
export * from "./processState2.vue?vue&type=script&lang=js"
import style0 from "./processState2.vue?vue&type=style&index=0&id=38997407&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38997407",
  null
  
)

export default component.exports